import React, { useState, useEffect } from "react";
import { Modal, Dropdown, Tab, Tabs } from "react-bootstrap";
import { getExternalTrainers, getInternalTrainers, getTrainers } from "../redux/groupWorkshop/actions";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../utils/AppUtils";
import GroupWorkshopTrainerShimmer from "./GroupWorkshopTrainerShimmer";
import _, { get } from 'lodash';
import ImageComponent from "../components/Layouts/ImageComponent";

const GroupWorksopTrainerList = ({
  show,
  onClose,
  onSelect,
  trainers,
  trainersList,
  setTrainersList,
  setSelectedTrainerId,
  SelectedTrainerId,
  setShowModal,
  setChips,
  chips,
  trainerIds
}) => {

  const dispatch = useDispatch();

  const [tList, setTList] = useState([]);
  const [trainerDetails, setTrainerDetails] = useState([]);
  const [internalList, setInternalList] = useState([]);
  const [externalList, setExternalList] = useState([]);
  const [selectedTrainerID, setSelectedTrainerIDs] = useState("");
  const [selectedCheckboxIds, setSelectedCheckboxIds] = useState([]);
  const [internalClicked, setInternalClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeButton, setActiveButton] = useState('internal');
  const [searchInput, setSearchInput] = useState("");

  const groupWorkshopStore = useSelector((state) => state.groupworkshop);
  const internalTrainersList = useSelector((state) => state.groupworkshop.internalTrainersList);
  const externalTrainersList = useSelector((state) => state.groupworkshop.externalTrainersList);
  // console.log("trainerList",trainersList)

  useEffect(() => {
    handleInternalClick()
  }, [show])

  useEffect(() => {
    if (!_.isEmpty(trainerIds)) {
      setSelectedCheckboxIds(trainerIds)
    }
  }, [trainerIds])

  useEffect(() => {
    if (searchInput) {
      setTList(tList.filter((trainer) => trainer.display_name.toLowerCase().includes(searchInput.toLowerCase())))
    }
  }, [searchInput])

  useEffect(() => {
    if (activeButton === 'internal' && !_.isEmpty(internalList)) {
      setTList(internalList);
      setIsLoading(false);
    }
    else if (activeButton === 'external' && !_.isEmpty(externalList)) {
      setTList(externalList);
      setIsLoading(false);
    }
  }, [activeButton])

  useEffect(() => {
    if (!_.isEmpty(internalTrainersList)) {
      const trainersListing = internalTrainersList;
      if (trainersListing?.status === "success") {
        if (!_.isEmpty(trainersListing?.payload?.payload)) {
          setInternalList(trainersListing?.payload?.payload);
        } else {
          setInternalList([]);
          activeButton === 'internal' && setTList([]);
        }
      } else {
        setInternalList([]);
        activeButton === 'internal' && setTList([]);
      }
      setIsLoading(false);
    }
  }, [internalTrainersList]);

  useEffect(() => {
    if (!_.isEmpty(externalTrainersList)) {
      const trainersListing = externalTrainersList;
      if (trainersListing?.status === "success") {
        if (!_.isEmpty(trainersListing?.payload?.payload)) {
          setExternalList(trainersListing?.payload?.payload);
        } else {
          setExternalList([]);
          activeButton === 'external' && setTList([]);
        }
      } else {
        setExternalList([]);
        activeButton === 'external' && setTList([]);
      }
      setIsLoading(false);
    }
  }, [externalTrainersList]);

  useEffect(() => {
    if (internalList.length > 0) {
      setTList(internalList);
      setTrainerDetails(internalList[0]);
      setSelectedTrainerIDs(internalList[0].id);
    } else {
      setTList([]);
      setTrainerDetails({});
      setSelectedTrainerIDs(""); 
    }

  }, [internalList]);

  useEffect(() => {
    if (externalList.length > 0) {
      setTList(externalList);
      setTrainerDetails(externalList[0]);
      setSelectedTrainerIDs(externalList[0].id);
    } else {
      setTList([]);
      setTrainerDetails({});
      setSelectedTrainerIDs(""); 
    }

  }, [externalList]);

  // useEffect(() => {
  //   if (trainersList.length > 0) {
  //     setTrainerDetails(trainersList[0]);
  //     setSelectedTrainerIDs(trainersList[0].id);
  //   }

  // }, [trainersList]);

  const handleExternalClick = () => {
    setActiveButton('external');
    setIsLoading(true);
    dispatch(
      getExternalTrainers({
        module: "getAllTrainers",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
          instructor_type: 'external'
        },
      })
    );
  }

  const handleSelectButtonClick = () => {
    setSelectedTrainerId((prevSelectedTrainerId) => {
      // Filter out IDs from `prevSelectedTrainerId` that are not in `selectedCheckboxIds`
      const updatedIds = prevSelectedTrainerId.filter((id) =>
        selectedCheckboxIds.includes(id)
      );
      // Add new selected IDs from `selectedCheckboxIds`
      const combinedIds = [...new Set([...updatedIds, ...selectedCheckboxIds])];
      console.log("Updated Selected Trainer IDs:", combinedIds);
      return combinedIds;
    });
    setChips((prevSelectedChips) => {
      const updatedIds = prevSelectedChips.filter((id) =>
        selectedCheckboxIds.includes(id)
      );
      const combinedChips = [
        ...new Set([...updatedIds, ...selectedCheckboxIds]),
      ];
      const combinedChipObjects = trainersList.filter((member) =>
        combinedChips.includes(member.id)
      );

      console.log("combinedChipObjects", combinedChipObjects);

      // Return the updated array of objects
      return combinedChipObjects;
    });

    setShowModal(false);
  };

  const handleCheckboxChange = (id, event) => {
    // If checkbox is checked, add the id to the array
    if (event.target.checked) {
      setSelectedCheckboxIds((prevSelectedIds) => [...prevSelectedIds, id]);
    } else {
      // If checkbox is unchecked, remove the id from the array
      setSelectedCheckboxIds((prevSelectedIds) =>
        prevSelectedIds.filter((selectedId) => selectedId !== id)
      );
    }
  };

  // console.log("selectedId", chips);

  const handleRowClick = (trainerData) => {
    setTrainerDetails(trainerData);
    setSelectedTrainerIDs(trainerData.id);
  };

  const handleInternalClick = () => {
    setActiveButton('internal');
    // setInternalClicked(true);
    setIsLoading(true);
    dispatch(
      getInternalTrainers({
        module: "getAllTrainers",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER) || "",
          instructor_type: 'internal'
        },
      })
    );
  }


  return (
    <Modal
      show={show}
      onHide={onClose}
      animation={true}
      centered
      size="xl"
      className="member-listpopup"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Trainer's List</h5>
      </Modal.Header>
      <Modal.Body className="tabel-bxd pt-0">
        <div className="contsection">
          <nav>
            <div className="nav-section-box" id="nav-tab" role="tablist">
              {/* <Tabs
                defaultActiveKey="Internal"
                id="uncontrolled-tab-example"
                className="mb-3"
              >
                <Tab eventKey="Internal" title="Internal">
                */}
              <ul className="mb-3 nav nav-tabs">
                <li className="nav-item"><
                  button className={`nav-link ${activeButton === 'internal' ? 'active' : ''}`} onClick={handleInternalClick}>Internal</button>
                </li>
                <li className="nav-item">
                  <button className={`nav-link ${activeButton === 'external' ? 'active' : ''}`} onClick={handleExternalClick}>External</button>
                </li>
              </ul>


              <div className="s-earch-and-filters d-flex gap-3 justify-content-between mb-4 flex-column flex-md-row">
                <div className="search-filter position-relative">
                  <input
                    type="search"
                    placeholder="Search"
                    id="inputPassword2"
                    className={`form-control ${(tList.length === 0 && !searchInput) ? "cursor-not-allowed" : ""}`}
                    // value=""
                    disabled={tList.length === 0 && !searchInput}
                    onChange={(e) => {
                      if (e.target.value) {
                        setSearchInput(e.target.value)
                      } else {
                        if (activeButton === 'internal') setTList(internalList);
                        else if (activeButton === 'external') setTList(externalList);
                      }
                    }}
                  />
                  {false && <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    //onClick={handleSearchClick}
                    className="cursor-pointer"
                  >
                    <path
                      d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                      fill="black"
                    />
                  </svg>}
                </div>
                {false && 
                <div className="filter-section">
                  <div className="filter-option-listing d-flex justify-content-end gap-3">
                    <Dropdown className="filter-btn">
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                      >
                        All Filters
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <path
                            d="M0 17.875C0 17.3164 0.429688 16.8438 1.03125 16.8438H3.56641C3.99609 15.4688 5.32812 14.4375 6.875 14.4375C8.37891 14.4375 9.71094 15.4688 10.1406 16.8438H20.9688C21.5273 16.8438 22 17.3164 22 17.875C22 18.4766 21.5273 18.9062 20.9688 18.9062H10.1406C9.71094 20.3242 8.37891 21.3125 6.875 21.3125C5.32812 21.3125 3.99609 20.3242 3.56641 18.9062H1.03125C0.429688 18.9062 0 18.4766 0 17.875ZM8.25 17.875C8.25 17.1445 7.60547 16.5 6.875 16.5C6.10156 16.5 5.5 17.1445 5.5 17.875C5.5 18.6484 6.10156 19.25 6.875 19.25C7.60547 19.25 8.25 18.6484 8.25 17.875ZM15.125 7.5625C16.6289 7.5625 17.9609 8.59375 18.3906 9.96875H20.9688C21.5273 9.96875 22 10.4414 22 11C22 11.6016 21.5273 12.0312 20.9688 12.0312H18.3906C17.9609 13.4492 16.6289 14.4375 15.125 14.4375C13.5781 14.4375 12.2461 13.4492 11.8164 12.0312H1.03125C0.429688 12.0312 0 11.6016 0 11C0 10.4414 0.429688 9.96875 1.03125 9.96875H11.8164C12.2461 8.59375 13.5781 7.5625 15.125 7.5625ZM16.5 11C16.5 10.2695 15.8555 9.625 15.125 9.625C14.3516 9.625 13.75 10.2695 13.75 11C13.75 11.7734 14.3516 12.375 15.125 12.375C15.8555 12.375 16.5 11.7734 16.5 11ZM20.9688 3.09375C21.5273 3.09375 22 3.56641 22 4.125C22 4.72656 21.5273 5.15625 20.9688 5.15625H11.5156C11.0859 6.57422 9.75391 7.5625 8.25 7.5625C6.70312 7.5625 5.37109 6.57422 4.94141 5.15625H1.03125C0.429688 5.15625 0 4.72656 0 4.125C0 3.56641 0.429688 3.09375 1.03125 3.09375H4.94141C5.37109 1.71875 6.70312 0.6875 8.25 0.6875C9.75391 0.6875 11.0859 1.71875 11.5156 3.09375H20.9688ZM6.875 4.125C6.875 4.89844 7.47656 5.5 8.25 5.5C8.98047 5.5 9.625 4.89844 9.625 4.125C9.625 3.39453 8.98047 2.75 8.25 2.75C7.47656 2.75 6.875 3.39453 6.875 4.125Z"
                            fill="#2D2D2D"
                          />
                        </svg>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="drop-down-menu">
                        <div
                          className="dropdown-menu-filter"
                          id="avail_menu"
                        >
                          <div className="dropdown-search">
                            <div className="dropdown-item-se pos-r">
                              <input
                                type="text"
                                className="form-control-search"
                                placeholder="Search content type"
                                value=""
                              />

                              <svg
                                className="filter-searchicon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                                  fill="black"
                                ></path>
                              </svg>
                            </div>
                          </div>
                          <div className="drop-multiselect">
                            <div className="dropdown-item bdr-row">
                              <div className="form-check checkallvalue">
                                <input
                                  aria-label="All"
                                  tabindex="0"
                                  type="checkbox"
                                  className="form-check-input"
                                  id="All"
                                />
                                <label
                                  className="form-check-label"
                                  id="All"
                                  for="All"
                                >
                                  All
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  aria-label="County"
                                  tabindex="0"
                                  type="checkbox"
                                  className="form-check-input"
                                  id="County"
                                />
                                <label
                                  className="form-check-label"
                                  id="County"
                                  for="County"
                                >
                                  County
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  aria-label="Role"
                                  tabindex="0"
                                  type="checkbox"
                                  className="form-check-input"
                                  id="Role"
                                />
                                <label
                                  className="form-check-label"
                                  id="Role"
                                  for="Role"
                                >
                                  Role
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  aria-label="Offices"
                                  tabindex="0"
                                  type="checkbox"
                                  className="form-check-input"
                                  id="Offices"
                                />
                                <label
                                  className="form-check-label"
                                  id="Offices"
                                  for="Offices"
                                >
                                  Offices
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  aria-label="Experiences"
                                  tabindex="0"
                                  type="checkbox"
                                  className="form-check-input"
                                  id="Experiences"
                                />
                                <label
                                  className="form-check-label"
                                  id="Experiences"
                                  for="Experiences"
                                >
                                  Experiences
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  aria-label="Industry"
                                  tabindex="0"
                                  type="checkbox"
                                  className="form-check-input"
                                  id="Industry"
                                />
                                <label
                                  className="form-check-label"
                                  id="Industry"
                                  for="Industry"
                                >
                                  Industry
                                </label>
                              </div>
                            </div>
                          </div>
                          <div
                            className="filter-btnrow d-flex justify-content-end gap-3"
                            id="avl_applybtn"
                          >
                            <button type="button" className="cancelbtn">
                              Clear filters
                            </button>
                            <button
                              type="submit"
                              className="btn-primary active-page"
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>}
              </div>
              {/* left content */}
              {isLoading ? <GroupWorkshopTrainerShimmer />
                :
                <div className="trainer-list-box d-flex ">
                  <div className="listing-trainer">
                    {
                      tList.length > 0 ? 
                      tList.map((trainer) => (
                        <div
                          // ${selectedTrainerID === trainer.id ? "selected" : ""}
                          className={`d-flex listviewtrainer ${selectedTrainerID === trainer.id ? "selected" : ""}
                            `}
                          onClick={() => handleRowClick(trainer)}
                        >
                          <div className="cehbox">
                            <input
                              type="checkbox"
                              className="form-check-input wb"
                              checked={selectedCheckboxIds.includes(trainer.id)} // Check if the current ID is selected
                              onChange={(e) =>
                                handleCheckboxChange(trainer.id, e)
                              }
                            />
                          </div>
                          <div className="coursebox-traienr">
                            <div className="trianerimg">
                              <img
                                src={trainer.profile ? trainer.profile : "https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png"}
                                alt="Trainer"
                                loading="lazy"
                                className={`${trainer.profile ? "" : "row-error-img"}`}
                              />
                            </div>
                            <div className="trainerinfo">
                              <div className="d-flex align-items-center gap-2">
                                {trainer.display_name &&
                                  <div className="nametraine">
                                    {trainer.display_name}
                                  </div>
                                }
                                {trainer.title &&
                                  <div className="pills">
                                    <div className="pill">{trainer.title}</div>
                                  </div>}
                              </div>
                              <div className="infotrainer">
                                {/* <span className="trainerico">
                                    
                                  </span> */}
                                <span className="trainerico">
                                  {trainer.experience && <span>Experience{" "}</span>}
                                  {trainer.experience && <strong>{trainer.experience}</strong>} |
                                  Skills{" "}
                                  <strong>
                                    {trainer?.skills?.map((skill, index) => (
                                      <span key={skill.id}>
                                        {skill.name}
                                        {index < trainer.skills.length - 1 &&
                                          ", "}
                                      </span>
                                    ))}
                                  </strong>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                      :
                      <div className="w-100 d-flex justify-content-center align-items-center">
                        <img src="/images/finwell-img/NoSearchResults.svg" alt="" />
                      </div>
                    }
                  </div>

                  {/* Right Side card */}
                  {
                  !_.isEmpty(trainerDetails) ?
                  <div className="coach-box">
                    <div className="above-info">
                      <div className="img-box-caoch">
                        {/* <ImageComponent 
                          name={trainerDetails.display_name}
                          thumbnail={trainerDetails.profile}
                          cssClass="img-fluid"
                          errorClass="img-fluid bk-grey w-100 h-100"
                          handleClick={() => {}}
                        /> */}
                        <img
                          src={trainerDetails.profile ? trainerDetails.profile : "https://cdnstg.training.com/halifax/image/10543/2016513182-20241212.png"}
                          className={`img-fluid ${trainerDetails.profile ? "" : "error-img"}`}
                          loading="lazy"
                          alt=""
                        />
                        <div className="overlay-box-ino d-flex justify-content-between">
                          {trainerDetails.title &&
                            <div className="infobox">
                              {trainerDetails.title}
                            </div>
                          }
                          {trainerDetails.experience &&
                            <div className="infobox">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                              >
                                <g clip-path="url(#clip0_935_21063)">
                                  <path
                                    d="M2.04761 10.502V14.6625H11.8704V10.502H2.04761Z"
                                    fill="#4D5E80"
                                  />
                                  <path
                                    d="M6.95898 10.502H11.8704V14.6625H6.95898V10.502Z"
                                    fill="#3D4566"
                                  />
                                  <path
                                    d="M6.5498 10.979H7.36838V12.2069H6.5498V10.979Z"
                                    fill="#FFDF40"
                                  />
                                  <path
                                    d="M6.95898 10.979H7.36827V12.2069H6.95898V10.979Z"
                                    fill="#FFBE40"
                                  />
                                  <path
                                    d="M9.00545 7.70463H8.18688V6.74502C7.91274 6.63658 7.42902 6.47677 6.95902 6.47677C6.48914 6.47677 6.0055 6.6365 5.73117 6.74505V7.70463H4.9126V6.22381L5.13885 6.11068C5.1758 6.09221 6.05423 5.6582 6.95902 5.6582C7.86381 5.6582 8.74225 6.09221 8.77919 6.11068L9.00545 6.22381V7.70463Z"
                                    fill="#4D5E80"
                                  />
                                  <path
                                    d="M8.18684 6.74502V7.70463H9.00541V6.22381L8.77916 6.11068C8.74221 6.09221 7.86378 5.6582 6.95898 5.6582V6.47677C7.42898 6.47677 7.9127 6.63658 8.18684 6.74502Z"
                                    fill="#3D4566"
                                  />
                                  <path
                                    d="M11.8704 7.29541V10.502L6.95903 11.3951L2.04761 10.502V7.29541H11.8704Z"
                                    fill="#3D4566"
                                  />
                                  <path
                                    d="M11.8704 7.29541H6.95898V11.3951L11.8704 10.502V7.29541Z"
                                    fill="#2E2E4D"
                                  />
                                  <path
                                    d="M3.57527 6.55573L2.20965 6.12819L0.844027 6.55573L0.828638 5.12484L0 3.95816L1.35612 3.50135L2.20965 2.35278L3.06317 3.50135L4.41929 3.95816L3.59068 5.12484L3.57527 6.55573Z"
                                    fill="#FFDF40"
                                  />
                                  <path
                                    d="M5.59351 4.91852L5.57812 3.48764L4.74951 2.32096L6.10564 1.86414L6.95916 0.715576L7.81265 1.86414L9.16878 2.32096L8.34017 3.48764L8.32481 4.91855L6.95916 4.49101L5.59351 4.91852Z"
                                    fill="#FFDF40"
                                  />
                                  <path
                                    d="M13.1561 6.55576L11.7904 6.12822L10.4248 6.55576L10.4094 5.12484L9.58081 3.95816L10.9369 3.50135L11.7904 2.35278L12.6439 3.50135L14 3.95816L13.1714 5.12484L13.1561 6.55576Z"
                                    fill="#FFDF40"
                                  />
                                  <path
                                    d="M8.32463 4.91852L8.33999 3.48761L9.1686 2.32096L7.81248 1.86414L6.95898 0.715576V4.49098L8.32463 4.91852Z"
                                    fill="#FFBE40"
                                  />
                                  <path
                                    d="M13.1559 6.55573L13.1713 5.12484L13.9999 3.95816L12.6438 3.50135L11.7903 2.35278V6.12819L13.1559 6.55573Z"
                                    fill="#FFBE40"
                                  />
                                  <path
                                    d="M3.57536 6.55573L3.59075 5.12484L4.41936 3.95816L3.06324 3.50135L2.20972 2.35278V6.12819L3.57536 6.55573Z"
                                    fill="#FFBE40"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_935_21063">
                                    <rect
                                      width="14"
                                      height="14"
                                      fill="white"
                                      transform="translate(0 0.688965)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>{" "}
                              Exp {trainerDetails.experience}
                            </div>
                          }
                        </div>
                      </div>
                      <div className="caoch-info">
                        <h4 className="coach-tiele">
                          {trainerDetails.display_name}
                        </h4>
                        <div className="coach-desx">
                          <p dangerouslySetInnerHTML={{ __html: trainerDetails.description }}></p>
                        </div>
                        {!_.isEmpty(trainerDetails?.skills) &&
                          <div className="key-skills-coach">
                            <p>
                              <strong>Key Skills</strong>
                            </p>
                            {trainerDetails?.skills?.map((skill, index) => (
                              <span key={skill.id}>
                                  {skill.name}
                                  {index < trainerDetails.skills.length - 1 &&
                                    ", "}
                              </span>
                            ))}
                          </div>
                        }


                        {(trainerDetails.linkdin_url || trainerDetails.x_url) &&
                          <div className="socliwra">
                            <p>
                              <strong>Portfolio/Profile Link</strong>
                            </p>
                            <div className="socililink-caoc">
                              {trainerDetails.linkdin_url && (
                                <div
                                  className="socl-icon cursor-pointer"
                                  onClick={() =>
                                    window.open(
                                      trainerDetails.linkdin_url,
                                      "_blank",
                                      "noopener,noreferrer"
                                    )
                                  }
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <g clip-path="url(#clip0_935_21044)">
                                      <path
                                        d="M21.829 0.688965H2.17099C0.972 0.688965 0 1.66096 0 2.85996V22.5179C0 23.717 0.972 24.689 2.17099 24.689H21.8289C23.028 24.689 24 23.717 24 22.5179V2.85996C24 1.66096 23.028 0.688965 21.829 0.688965ZM7.42662 21.4121C7.42662 21.7611 7.14377 22.0439 6.79483 22.0439H4.10544C3.7565 22.0439 3.47365 21.7611 3.47365 21.4121V10.1384C3.47365 9.78942 3.7565 9.50658 4.10544 9.50658H6.79483C7.14377 9.50658 7.42662 9.78942 7.42662 10.1384V21.4121ZM5.45014 8.44385C4.0391 8.44385 2.8952 7.29996 2.8952 5.88892C2.8952 4.47789 4.0391 3.33399 5.45014 3.33399C6.86117 3.33399 8.00507 4.47789 8.00507 5.88892C8.00507 7.29996 6.86124 8.44385 5.45014 8.44385ZM21.4813 21.463C21.4813 21.7838 21.2212 22.0439 20.9004 22.0439H18.0145C17.6937 22.0439 17.4335 21.7838 17.4335 21.463V16.175C17.4335 15.3861 17.6649 12.7182 15.372 12.7182C13.5934 12.7182 13.2327 14.5443 13.1602 15.3638V21.463C13.1602 21.7838 12.9002 22.0439 12.5793 22.0439H9.78817C9.46737 22.0439 9.20727 21.7838 9.20727 21.463V10.0875C9.20727 9.76668 9.46737 9.50658 9.78817 9.50658H12.5793C12.9001 9.50658 13.1602 9.76668 13.1602 10.0875V11.071C13.8197 10.0813 14.7998 9.3174 16.8866 9.3174C21.5077 9.3174 21.4813 13.6346 21.4813 16.0067V21.463Z"
                                        fill="#0077B7"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_935_21044">
                                        <rect
                                          width="24"
                                          height="24"
                                          fill="white"
                                          transform="translate(0 0.688965)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                              )}

                              {trainerDetails.x_url && (
                                <div
                                  className="socl-icon cursor-pointer"
                                  onClick={() =>
                                    window.open(
                                      trainerDetails.x_url,
                                      "_blank",
                                      "noopener,noreferrer"
                                    )
                                  }
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="25"
                                    viewBox="0 0 24 25"
                                    fill="none"
                                  >
                                    <g clip-path="url(#clip0_935_21046)">
                                      <path
                                        d="M12.8025 12.2793L18.2033 20.0045H15.9868L11.5796 13.7007V13.7003L10.9325 12.7749L5.78418 5.41064H8.00071L12.1554 11.3539L12.8025 12.2793Z"
                                        fill="black"
                                      />
                                      <path
                                        d="M21.4067 0.688965H2.59325C1.16108 0.688965 0 1.85004 0 3.28222V22.0957C0 23.5279 1.16108 24.689 2.59325 24.689H21.4067C22.8389 24.689 24 23.5279 24 22.0957V3.28222C24 1.85004 22.8389 0.688965 21.4067 0.688965ZM15.308 21.0414L10.8481 14.5507L5.26435 21.0414H3.82122L10.2073 13.6185L3.82122 4.32417H8.69203L12.9152 10.4705L18.2026 4.32417H19.6458L13.5562 11.4029H13.5558L20.1788 21.0414H15.308Z"
                                        fill="black"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_935_21046">
                                        <rect
                                          width="24"
                                          height="24"
                                          fill="white"
                                          transform="translate(0 0.688965)"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                </div>
                              )}
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  :
                  ""
                  }
                </div>
              }
            </div>
          </nav>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end p-3">
        <div className="d-flex justify-content-end gap-3 btn-footer">
          <button type="button" className="btn-primary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary active-page"
            onClick={handleSelectButtonClick}
          >
            Select
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default GroupWorksopTrainerList;
